import React from "react";

export interface ITimerProps {
    expired: () => void;
    estimationTime: { minutes: number; seconds: number; }
}

export class Timer extends React.Component<ITimerProps, { time?: { m: number; s: number; }, seconds: number }> {
    private timer: any;
    constructor(props: ITimerProps) {
        super(props);
        this.state = { time: { m: props.estimationTime.minutes, s: props.estimationTime.seconds }, seconds: props.estimationTime.minutes * 60 + props.estimationTime.seconds };
        this.timer = 0;
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
    }

    secondsToTime(secs: number) {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    componentDidMount() {
        let timeLeftVar = this.secondsToTime(this.state.seconds);
        this.setState({ time: timeLeftVar });
    }

    componentWillUnmount() {
        if (this.timer)
            clearInterval(this.timer);
    }

    startTimer() {
        if (this.timer === 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    countDown() {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;
        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
        });

        // Check if we're at zero.
        if (seconds === 0) {
            clearInterval(this.timer);
            this.props.expired();
        }
    }

    render() {
        this.startTimer();
        return (
            <div style={{ float: "left", direction: "ltr", display: "inline", width: 50 }}>
                {this.state.time?.m.toString().padStart(2, "0")} : {this.state.time?.s.toString().padStart(2, "0")}
            </div>
        );
    }
}